document.addEventListener("DOMContentLoaded", function() {
    const firstVideo = document.querySelector('video');
    if (firstVideo) {
      firstVideo.autoplay = true;
      firstVideo.muted = true;
      firstVideo.playsInline = true;
      firstVideo.load();
    }
});